import React, {Component} from 'react'
import RepaymentInitiatedListUI from './RepaymentInitiatedListUI'
import CacheManager from '../../../cache/CacheManager'
import CacheKeys from '../../../cache/CacheKeys'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class RepaymentInitiatedListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      scheduledDate: null,
      copyToClipboardText: null,
      searchFilter: '',
      filteredRepaymentList: [],
      //
      declineSubmitted: false,
      declineSuccessMsg: null,
      declineErrorList: null,
      approveSubmitted: false,
      approveSuccessMsg: null,
      approveErrorList: null,
      //
      showDetails: false,
      selectedRowId: null,
    }
  }

  render() {
    return (
      <RepaymentInitiatedListUI
        context={this.props.context}
        repaymentList={this.props.repaymentList}
        //
        onRefreshClick={this.props.onRefreshClick}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        //
        declineSubmitted={this.state.declineSubmitted}
        declineSuccessMsg={this.state.declineSuccessMsg}
        declineErrorList={this.state.declineErrorList}
        onDeclineClick={this.onDeclineClick}
        //
        approveSubmitted={this.state.approveSubmitted}
        approveSuccessMsg={this.state.approveSuccessMsg}
        approveErrorList={this.state.approveErrorList}
        onApproveClick={this.onApproveClick}
        //
        showDetails={this.state.showDetails}
        onShowDetails={this.onShowDetails}
        selectedRowId={this.state.selectedRowId}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    let filtersStr = sessionStorage.getItem(CacheKeys.RepaymentsInitFilter())
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(this.props.repaymentList, filters.searchFilter ? filters.searchFilter : '')
  }

  onShowDetails = (event) => {
    let rowId = event.target.getAttribute('data-row-id')
    if (this.state.selectedRowId === rowId) {
      this.setState({
        showDetails: !this.state.showDetails,
      })
    }
    else {
      this.setState({
        showDetails: true,
        selectedRowId: rowId
      })
    }
  }

  onApproveClick = (event) => {
    if (this.state.approveSubmitted || this.state.declineSubmitted)
      return

    let rowId = event.target.getAttribute('data-row-id')
    let parts = rowId.split(':')
    this.setState({
      approveSubmitted: true,
      approveErrorList: [],
      scheduledDate: parts[1],
      selectedRowId: rowId
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${parts[0]}/repayments/scheduledDates/${parts[1]}/approvals`,
      this.onApproveClickCallback, {}
    )
  }

  onApproveClickCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      approveSuccessMsg: response.success,
      approveErrorList: errorList,
      approveSubmitted: false,
    })

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({approveSuccessMsg: null, approveErrorList: []})
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  onDeclineClick = (event) => {
    if (this.state.approveSubmitted || this.state.declineSubmitted)
      return

    let rowId = event.target.getAttribute('data-row-id')
    let parts = rowId.split(':')
    this.setState({
      declineSubmitted: true,
      declineErrorList: [],
      scheduledDate: parts[1],
      selectedRowId: rowId
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${parts[0]}/repayments/scheduledDates/${parts[1]}/declines`,
      this.onDeclineClickCallback, {}
    )
  }

  onDeclineClickCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      declineSuccessMsg: response.success,
      declineErrorList: errorList,
      declineSubmitted: false,
    })

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({approveSuccessMsg: null})
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.props.repaymentList, searchFilter)
  }

  applyFilters(repaymentList, searchFilter) {
    let filteredList = repaymentList
    if (searchFilter) {
      searchFilter = searchFilter.toLocaleLowerCase()
      filteredList = filteredList.filter(repayment =>
        repayment.accountName.toLocaleLowerCase().includes(searchFilter)
      )
    }

    this.setState({
      filteredRepaymentList: filteredList,
      searchFilter: searchFilter,
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.LoansFilter(), JSON.stringify(filters))
  }

  onCopyToClipboard = (text, result) => {
    this.setState({copyToClipboardText: text})
    setTimeout(() => {
      this.setState({copyToClipboardText: null})
    }, 3000)
  }
}

export default RepaymentInitiatedListSF
